import { CHUNK_DEPTH, CHUNK_HEIGHT, CHUNK_WIDTH } from './chunks'

const total = CHUNK_WIDTH * CHUNK_HEIGHT * CHUNK_DEPTH

// unpacked Uint16Array -> packed Uint16Array
export function encodeChunk(index) {
  if (index.length !== total) {
    throw new Error(`encodeChunk: index length ${index.length} expected ${total}`)
  }
  const pairs = []
  let curr = index[0] >>> 0
  let run = 1
  for (let i = 1; i < index.length; i++) {
    const v = index[i] >>> 0
    if (v === curr) {
      run++
    } else {
      pairs.push(curr, run)
      curr = v
      run = 1
    }
  }
  pairs.push(curr, run)
  return Uint16Array.from(pairs)
}

// packed Uint16Array -> unpacked Uint16Array
export function decodeChunk(data) {
  const index = new Uint16Array(total)
  let pos = 0
  for (let i = 0; i < data.length; i += 2) {
    const value = data[i] >>> 0
    const run = data[i + 1] >>> 0
    index.fill(value, pos, pos + run)
    pos += run
  }
  return index
}
